<template>
	<div id="personalProcurement">
		<div class="personalaccount_content">
			<div class="personalaccount_content_left">
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						个人资料
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalaccount" class="">基本信息</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalAddress" class="">收货地址</router-link>
						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						安全设置
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalXg" class="">修改密码</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalPhone">手机绑定</router-link>
						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						账号绑定
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalWechart" class="">微信绑定</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalEmail" class="">邮箱绑定</router-link>
						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item" v-if="sign == 1 || sign == 2">
					<div class="personalaccount_content_left_item_head">
						集团账号管理
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box " v-if="sign == 1">
							<router-link to="/personalCgr" class="">采购员管理</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box select_box">
							<router-link to="/personalProcurement" class="select_box">采购订单 </router-link>

						</div>
					</div>
				</div>
			</div>
			<div class="personalaccount_content_right">

				<div class="personalaccount_content_right_head">
					<div class="personalaccount_content_right_head_left">
						商品列表
					</div>
					<div style="cursor: pointer;" @click="backFn()">
						返回
					</div>
				</div>

				<div class="personalaccount_content_right_content">
					<el-table :data="detailData.sku" border style="width: 100%" :header-cell-style="getRowClass" :cell-style="cellStyle">
						<el-table-column prop="name" label="商品名称" width="420">
							<template slot-scope="scope">
								<div class="name_item" @click="jumpDetails(scope.row)">
									<div class="name_item_left">
										<img :src="http + scope.row.goods_image" />
									</div>
									<div class="name_item_right txtnowarp2">
										{{scope.row.goods_name}}
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="goods_spec_value" label="属性">
						</el-table-column>
						<el-table-column label="本店价">
							<template slot-scope="scope">
								{{(scope.row.price * 1).toFixed(2)}}
							</template>
						</el-table-column>
						<el-table-column prop="number" label="购买数量">
						</el-table-column>
						<el-table-column label="小计">
							<template slot-scope="scope">
								{{(scope.row.price * scope.row.number * scope.row.package).toFixed(2)}}
							</template>
						</el-table-column>

					</el-table>
				</div>
				<div class="personalaccount_content_right_footer">
					<div class="personalaccount_content_right_footer_left">
						费用总计
					</div>
					<div class="personalaccount_content_right_footer_center">
						订单完成后您可获得{{getjifen}}积分。
					</div>
					<div class="personalaccount_content_right_footer_right">
						<div class="personalaccount_content_right_footer_right_con">
							<span class="personalaccount_content_right_footer_right_con1">商品总额：</span>
							<span class="personalaccount_content_right_footer_right_con4">￥{{detailData.payment}}</span>
						</div>
						<div class="personalaccount_content_right_footer_right_con">
							<span class="personalaccount_content_right_footer_right_con1">物流费用：</span>
							<span class="personalaccount_content_right_footer_right_con2">+{{detailData.postage}}</span>
						</div>
						<div class="personalaccount_content_right_footer_right_con" v-if="youhuilv != 1">
							<span class="personalaccount_content_right_footer_right_con1">优惠率：</span>
							<span class="personalaccount_content_right_footer_right_con2">{{youhuilv}}</span>
						</div>
						<div class="personalaccount_content_right_footer_right_con">
							<span class="personalaccount_content_right_footer_right_con1">积分抵扣：</span>
							<span class="personalaccount_content_right_footer_right_con4">-{{(detailData.integral * bili).toFixed(2)}}</span>
						</div>

						<div class="personalaccount_content_right_footer_right_con">
							<span class="personalaccount_content_right_footer_right_con5">订单总额：</span>
							<span class="personalaccount_content_right_footer_right_con3">￥{{((Number(detailData.payment) + Number(detailData.postage) - (detailData.integral * bili)) * youhuilv).toFixed(2)}}</span>
						</div>

					</div>
				</div>
				<div class="footer_btn" v-if="detailData.status == 1 && sign == 1">
					<div class="shenhe_btn_" @click="xiugaiFn(3)">驳回</div>
					<div class="shenhe_btn" @click="xiugaiFn(2)">通过审核</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
	import qs from "qs";
	import md5 from 'blueimp-md5'
	export default {
		name: 'personalProcurements',

		data() {
			return {
				fixedkey: false,
				tableData: [],
				sign: '',
				dingdanData: {}, //详情获取参数
				caigouId: '', //获取采购订单详情id
				detailData: {}, //详情数据
				http: '', //图片域名
				youhuilv: 1, //优惠率
				jifenZong: 0, //总积分
				bili: 0, //积分比例
				getjifen: 0, //获取多少积分

			}
		},
		created() {
			let that = this;
			//			that.ScrollUp();
			that.http = that.$publicUrl.http1;
			if(that.$storage.get('user_data') != null) {
				that.sign = that.$storage.get('user_data').sign
				that.dingdanData['user_id'] = that.$storage.get('user_data').user_id;

				that.caigouId = that.$route.query.id;
				that.huoquDingdans();
				that.jifenFn();

				// that.localData['state'] = 0;
			} else {

			}
		},
		mounted() {

			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				console.log()
				if(scrollTop >= 300) {
					this.fixedkey = true
				} else {
					this.fixedkey = false

				}
			},
			huoquDingdans() {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.purchaseshow,
						data: qs.stringify({
							id: that.caigouId,

						}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						if(data.stateCode == 10000) {

							that.detailData = data.data;
							console.log(data.data)

						} else {

						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			backFn() {
				let that = this;
				that.$router.go(-1);
			},
			jifenFn() {
				let that = this;

				axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.jifennumber,
						data: qs.stringify({
							user_id: that.$storage.get('user_data').user_id,
							rank: that.$storage.get('user_data').rank_id,
							money: Number(that.detailData.payment) + Number(that.detailData.postage),
						}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						console.log(data)
						if(data.stateCode == 10000) {
							that.jifenZong = data.jifen
							that.bili = data.bili
							that.getjifen = data.get
							that.youhuilv = data.rate

						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			xiugaiFn(status) {
				let that = this;
				that.$confirm("您将审批该条订单?", "系统提示", {
						confirmButtonText: "确定审批",
						cancelButtonText: "我再想想",
						center: true,
						customClass: "alertboxq",
						confirmButtonClass: "alertboxqbtn1"
					})
					.then(() => {
						axios({
						method: 'post',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
						},
						url: that.$publicUrl.http1 + that.$publicUrl.purchasesaveStatus,
						data: qs.stringify({
							audit_id: that.$storage.get('user_data').user_id,
							id: that.detailData.id,
							status: status
						}),

					})
					.then(function(response) {
						//						console.log(response);
						let data = response.data;
						console.log(data)
						if(data.stateCode == 10000) {
							that.$message({
								message: '审核成功~',
								type: 'success'
							});
							that.$router.push({
								path: '/personalProcurement',
								query: {
								
								}
							})

						} else {
							that.$message({
								message: data.msg,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
					})
					.catch(() => {});
				
			},
			getRowClass({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if(rowIndex === 0) {
					return "background: #eeeeee;font-size:18px;color:#333333;text-align:center;font-weight:500";
				} else {
					return "";
				}
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if(columnIndex == 5) {
					return "text-align:center;font-size:16px;color:#666666;";
				} else {
					return "text-align:center;font-size:16px;color:#666666;";
				}

			},
			handleEdit(index, row) {
				console.log(index, row);

			},

		},

	}
</script>

<style scoped="scoped">
	.name_item {
		width: 100%;
		display: flex;
		flex-wrap: nowrap;
		cursor: pointer;
	}
	
	.name_item_left {
		width: 80px;
		height: 80px;
		/*border: 1px solid #cccccc;*/
		padding: 5px;
		box-sizing: border-box;
	}
	
	.name_item_left img {
		display: inline-block;
		width: 100%;
	}
	
	.name_item_right {
		width: calc(100% - 120px);
		height: 45px;
		margin-top: 20px;
		margin-left: 20px;
	}
	
	#personalProcurement {
		width: 100%;
		background-color: #f6f6f6;
		padding-top: 20px;
		padding-bottom: 20px;
	}
	
	.personalaccount_content {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: nowrap;
		align-items: self-start;
	}
	
	.personalaccount_content_left {
		width: 170px;
		text-align: center;
		background: #ffffff;
		/*height: 620px;*/
	}
	
	.personalaccount_content_left_item_head {
		width: 100%;
		height: 50px;
		line-height: 50px;
		background: #dddddd;
		color: #333333;
		font-size: 18px;
		font-weight: 550;
	}
	
	.personalaccount_content_left_item_content {
		width: 100%;
	}
	
	.personalaccount_content_left_item_content_box {
		font-size: 16px;
		color: #333333;
		width: 100%;
		height: 40px;
		margin-top: 10px;
		line-height: 40px;
	}
	
	.select_box {
		background: #DC1E33;
		color: #ffffff;
	}
	
	.personalaccount_content_left_item_content_box span {
		color: #DC1E33;
	}
	
	.personalaccount_content_right {
		width: 1010px;
		margin-left: 20px;
	}
	
	.personalaccount_content_right_head1 {
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		width: 100%;
		background: #eeeeee;
		color: #333333;
		font-size: 18px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		margin-bottom: 20px;
	}
	
	.personalaccount_content_right_head {
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		width: 100%;
		background: #fe818d;
		color: #ffffff;
		font-size: 18px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	
	.personalaccount_content_right_content {
		width: 100%;
		margin: 0 auto;
		margin-top: 20px;
		background: #ffffff;
	}
	
	.table_th {
		background: #eeeeee;
		font-size: 18px;
		color: #333333;
		text-align: center;
		border-right: 1px solid #dddddd;
		font-weight: 500;
	}
	
	.personalaccount_content_right_footer {
		display: flex;
		flex-wrap: nowrap;
		width: 100%;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 10px;
		/*height: 200px;*/
		background: #ffffff;
		margin-top: 20px;
	}
	
	.personalaccount_content_right_footer_left {
		height: calc(100% - 20px);
		line-height: 150px;
		color: #333333;
		font-size: 24px;
	}
	
	.personalaccount_content_right_footer_center {
		width: 410px;
		font-size: 16px;
		color: #333333;
		height: 120px;
		box-sizing: border-box;
		padding-top: 70px;
	}
	
	.personalaccount_content_right_footer_right_con {
		font-size: 16px;
		color: #333333;
		height: 35px;
		line-height: 35px;
	}
	
	.personalaccount_content_right_footer_right_con1 {
		display: inline-block;
		width: 100px;
		text-align: right;
	}
	
	.personalaccount_content_right_footer_right_con2 {
		color: #dc1e33;
	}
	
	.personalaccount_content_right_footer_right_con3 {
		font-size: 20px;
		color: #dc1e33;
	}
	
	.footer_btn {
		width: 400px;
		margin: 60px auto;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	
	.shenhe_btn_ {
		width: 150px;
		height: 40px;
		line-height: 40px;
		border-radius: 5px;
		background: #ffffff;
		border: 1px solid #dddddd;
		font-size: 18px;
		text-align: center;
		color: #333333;
		cursor: pointer;
	}
	
	.shenhe_btn {
		width: 150px;
		height: 40px;
		line-height: 40px;
		border-radius: 5px;
		background: #D81023;
		border: 1px solid #dddddd;
		font-size: 18px;
		text-align: center;
		color: #ffffff;
		cursor: pointer;
	}
</style>